// 项目类型字典
export const projectTypeDic = [
  { label: "防水", value: "WATERPROOF" },
  { label: "回填", value: "BACKFILL" },
  { label: "吊顶", value: "HANG_CEILING" },
];

// 价盘状态字典
export const priceBookStatusDic = [
  { label: "启用", value: "ENABLE" },
  { label: "停用", value: "DISABLE" },
];

// 是否兜底字典
export const isFallbackDic = [
  { label: "普通", value: "NO" },
  { label: "兜底", value: "YES" },
];

// 价目表（价盘）列表表格配置
export const priceBookTableOption = {
  align: "center",
  menuAlign: "center",
  headerAlign: "center",
  border: true,
  expand: false,
  stripe: true,
  showHeader: true,
  index: true,
  indexLabel: "序号",
  selection: true,
  menu: true,
  menuWidth: 360,
  page: true,
  addBtn: false,
  editBtn: false,
  delBtn: false,
  viewBtn: false,
  menuType: "text",
  column: [
    {
      label: "价目表名称",
      prop: "name",
      search: true,
      searchPlaceholder: "请输入价目表名称",
      type: "input",
      minWidth: 160,
    },
    {
      label: "项目类型",
      prop: "projectType",
      type: "select",
      dicData: projectTypeDic,
      search: true,
      width: 100,
    },
    {
      label: "价盘编号",
      prop: "code",
      minWidth: 120,
    },
    {
      label: "优先级",
      prop: "priority",
      width: 80,
    },
    {
      label: "是否兜底",
      prop: "isFallback",
      type: "select",
      dicData: isFallbackDic,
      search: true,
      slot: true,
      width: 90,
    },
    {
      label: "兜底基价(元/㎡)",
      prop: "basePrice",
      slot: true,
      width: 120,
    },
    {
      label: "阈值",
      prop: "threshold",
      slot: true,
      width: 100,
    },
    {
      label: "生效开始",
      prop: "effectiveStartTime",
      slot: true,
      type: "datetime",
      valueFormat: "yyyy-MM-dd HH:mm:ss",
      format: "yyyy-MM-dd HH:mm:ss",
      width: 150,
    },
    {
      label: "生效结束",
      prop: "effectiveEndTime",
      slot: true,
      type: "datetime",
      valueFormat: "yyyy-MM-dd HH:mm:ss",
      format: "yyyy-MM-dd HH:mm:ss",
      width: 150,
    },
    {
      label: "生效状态",
      prop: "effectiveStatus",
      slot: true,
      width: 100,
    },
    {
      label: "状态",
      prop: "status",
      type: "select",
      dicData: priceBookStatusDic,
      search: true,
      slot: true,
      width: 90,
    },
    {
      label: "创建时间",
      prop: "createTime",
      slot: true,
      type: "datetime",
      valueFormat: "yyyy-MM-dd HH:mm:ss",
      format: "yyyy-MM-dd HH:mm:ss",
      width: 150,
    },
  ],
};
